import React, { FC } from 'react'
import classnames from 'classnames'
import { IURL } from '@api'
import { DivProps } from '@commonTypes'
import { Classes } from '@blueprintjs/core'
import { getInitials } from '@utils'
import css from './avatar.module.scss'

export enum Size {
  XXS,
  XS,
  SM,
  MD,
  XMD,
  LG,
}

interface AvatarProps {
  clickable?: boolean
  changeable?: boolean
  name?: string
  assets?: IURL[]
  skeleton?: boolean
  size?: Size
  style?: any
}

export default function Avatar({
  changeable,
  clickable,
  skeleton,
  name,
  assets,
  size,
  style,
}: AvatarProps) {
  let width = 20
  let fontSize = 10

  switch (size) {
    case Size.XXS:
      width = 16
      fontSize = 8
      break

    case Size.XS:
      width = 30
      fontSize = 12
      break

    case Size.SM:
      width = 40
      fontSize = 16
      break

    case Size.XMD:
      width = 64
      fontSize = 30
      break

    case Size.MD:
      width = 80
      fontSize = 30
      break

    case Size.LG:
      width = 140
      fontSize = 42
      break
  }

  let avatar = null
  if (assets && assets.length && assets?.[0]?.url) {
    avatar = (
      <Image
        {...{ clickable, changeable }}
        style={{
          width,
          height: width,
          flex: `0 0 ${width}px`,
          backgroundImage: `url("${assets[0].url}")`,
          backgroundSize: 'contain',
        }}
      />
    )
  } else {
    avatar = (
      <Initials
        {...{ clickable, changeable }}
        className={skeleton ? Classes.SKELETON : ''}
        style={{
          width,
          height: width,
          flex: `0 0 ${width}px`,
          fontSize,
          ...style,
        }}>
        {name && getInitials(name)}
      </Initials>
    )
  }

  return avatar
}

Avatar.Size = Size

interface ICircleProps {
  changeable?: boolean
  clickable?: boolean
}

const Initials: FC<React.PropsWithChildren<DivProps & ICircleProps>> = ({
  changeable,
  clickable,
  className,
  ...props
}) => {
  return (
    <div
      className={classnames(css.initials, className, {
        [css.initials__clickable]: clickable,
        [css.initials__changeable]: changeable,
      })}
      {...props}
    />
  )
}

const Image: FC<React.PropsWithChildren<DivProps & ICircleProps>> = ({
  changeable,
  clickable,
  className,
  ...props
}) => {
  return (
    <div
      className={classnames(css.initials, className, {
        [css.image__clickable]: clickable,
        [css.image__changeable]: changeable,
      })}
      {...props}
    />
  )
}
